import { useInfiniteQuery } from "react-query";
import {
  RelatorioUnidadesPaginadoItem,
  FiltroRelatorioUnidades,
} from "../typings";
import http from "infra/http";
import { PaginateResult } from "core/resources/types/shared";

function useRelatorioUnidadesInfiniteScroll(query: FiltroRelatorioUnidades) {
  return useInfiniteQuery(
    [`/v1/relatorios/unidades/paginado`, query],
    async ({ pageParam }) => {
      const { data } = await http.get<
        PaginateResult<RelatorioUnidadesPaginadoItem>
      >("/v1/relatorios/unidades/paginado", {
        params: { ...query, page: pageParam ?? 1 },
      });

      return data;
    },
    {
      getNextPageParam: (lastPage) =>
        lastPage.meta.currentPage >= lastPage.meta.totalPages
          ? undefined
          : lastPage.meta.currentPage + 1,
    }
  );
}

export default useRelatorioUnidadesInfiniteScroll;
